module.exports = __webpack_public_path__ + "img/Dantam Makeover 09.005a253c.jpg";